import React from "react"
import { Box, Flex, VStack, Text, Link } from "@chakra-ui/react"

import { textStyles } from "../sections/articles/Content"

const LinksAndDownloads = ({ data }) => {
  const { downloadsBottom, weiterfuehrendeLinks, kontakt } = data
  return (
    <>
      {(weiterfuehrendeLinks || downloadsBottom) && (
        <Flex
          mt={16}
          mr={{ base: 0, lg: 8 }}
          flexDirection={{ base: "column", md: "row" }}
        >
          {weiterfuehrendeLinks && <Links links={weiterfuehrendeLinks} />}
          {downloadsBottom && (
            <Downloads
              downloads={downloadsBottom}
              linksAvailable={weiterfuehrendeLinks}
            />
          )}
        </Flex>
      )}

      {kontakt && (
        <Box
          id="kontakt"
          pt={2}
          mr={{ base: 0, lg: 8 }}
          mt={16}
          borderTop="1px"
          borderColor="dark_blue"
        >
          <Titel>Kontakt:</Titel>
          <Box
            dangerouslySetInnerHTML={{ __html: kontakt }}
            whiteSpace="initial"
            sx={textStyles}
            lineHeight="1.3125rem"
          />
        </Box>
      )}
    </>
  )
}

export default LinksAndDownloads

const Titel = ({ children }) => (
  <Text
    fontFamily="CocoSharpL-Bold"
    textTransform="uppercase"
    letterSpacing="1px"
    fontSize="0.875rem"
    mb={3}
    mt={1}
  >
    {children}
  </Text>
)

const Links = ({ links }) => {
  return (
    <Box
      id="weiterfuehrende-links"
      width={{ base: "100%", md: "50%" }}
      pt={2}
      pr={{ md: 4 }}
      borderTop="1px"
      borderColor="dark_blue"
    >
      <Titel>Weiterführende Links</Titel>
      <VStack align="flex-start" spacing={4}>
        {links.map((item, index) => {
          return (
            <Link
              key={`${item.linkText}-${index}`}
              href={item.link}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Flex dir="row" justify="flex-start">
                <Box w="22px" mr={3}>
                  <ArrowLink />
                </Box>
                <Text
                  as="span"
                  fontFamily="CocoSharpL-Bold"
                  fontSize="0.875rem"
                  lineHeight="1.25rem"
                >
                  {item.linkText}
                </Text>
              </Flex>
            </Link>
          )
        })}
      </VStack>
    </Box>
  )
}

const Downloads = ({ downloads }) => {
  return (
    <Box
      id="downloads"
      width={{ base: "100%", md: "50%" }}
      pt={2}
      mt={{ base: 16, md: 0 }}
      borderTop="1px"
      borderColor="dark_blue"
    >
      <Titel>Downloads</Titel>
      <VStack align="flex-start" spacing={4}>
        {downloads.map((item, index) => {
          return (
            <Link
              key={`${item.downloadLinkText}-${index}`}
              href={item.downloadLinkDatei?.localFile.publicURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Flex dir="row" justify="flex-start">
                <Box w="22px" mr={3}>
                  <ArrowDownload />
                </Box>
                <Text
                  as="span"
                  fontFamily="CocoSharpL-Bold"
                  fontSize="0.875rem"
                  lineHeight="1.25rem"
                >
                  {item.downloadLinkText}
                </Text>
              </Flex>
            </Link>
          )
        })}
      </VStack>
    </Box>
  )
}

const ArrowLink = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.708"
    height="22.627"
    viewBox="0 0 20.708 22.627"
    style={{ display: "inline" }}
  >
    <g
      id="Group_331"
      data-name="Group 331"
      transform="translate(-476.384 -4398.687)"
    >
      <g
        id="Group_330"
        data-name="Group 330"
        transform="translate(-35.106 -64)"
      >
        <line
          id="Line_42"
          data-name="Line 42"
          y1="20"
          transform="translate(531.49 4474) rotate(90)"
          fill="none"
          stroke="#1e1e1e"
          strokeWidth="2"
        />
        <line
          id="Line_41"
          data-name="Line 41"
          y1="15"
          transform="translate(520.884 4463.394) rotate(-45)"
          fill="none"
          stroke="#1e1e1e"
          strokeWidth="2"
        />
        <line
          id="Line_45"
          data-name="Line 45"
          y1="15"
          transform="translate(531.491 4474) rotate(45)"
          fill="none"
          stroke="#1e1e1e"
          strokeWidth="2"
        />
      </g>
    </g>
  </svg>
)

const ArrowDownload = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="30"
    height="31.001"
    viewBox="0 0 30 31.001"
    style={{ display: "inline" }}
  >
    <g
      id="Group_331"
      data-name="Group 331"
      transform="translate(4432.894 -476.999) rotate(90)"
    >
      <g
        id="Group_330"
        data-name="Group 330"
        transform="translate(-35.106 -64)"
      >
        <line
          id="Line_44"
          data-name="Line 44"
          y1="30"
          transform="translate(542.106 4466.894)"
          fill="none"
          stroke="#1e1e1e"
          strokeWidth="2"
        />
        <g
          id="Group_333"
          data-name="Group 333"
          transform="translate(35.721 71.894)"
        >
          <g
            id="Group_330-2"
            data-name="Group 330"
            transform="translate(-35.106 -64)"
          >
            <line
              id="Line_42"
              data-name="Line 42"
              y1="20"
              transform="translate(531.49 4474) rotate(90)"
              fill="none"
              stroke="#1e1e1e"
              strokeWidth="2"
            />
            <line
              id="Line_41"
              data-name="Line 41"
              y1="15"
              transform="translate(520.884 4463.394) rotate(-45)"
              fill="none"
              stroke="#1e1e1e"
              strokeWidth="2"
            />
            <line
              id="Line_45"
              data-name="Line 45"
              y1="15"
              transform="translate(531.491 4474) rotate(45)"
              fill="none"
              stroke="#1e1e1e"
              strokeWidth="2"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
)
